import Card from 'react-bootstrap/Card';  //sul sito https://react-bootstrap.github.io/components/cards/
import '../style/card.css'

const myCard = ({title,text,subtext}) => { //props destrutturate del componente riutilizzabile
  return (
    <>
      <Card className="myCard">        
        <Card.Body>
          <Card.Title className="cardTitle">{title}</Card.Title>       
          <Card.Text className="cardText">{text}</Card.Text>     
          <Card.Text className="cardSubText">{subtext}</Card.Text>      
        </Card.Body>
      </Card>
    </>
  );
}

export default myCard